import StorageStore from "../Common/Storage/storageStore";
import UserContextOld from "./UserContextOld";

class UserTokenContext {
    static token: string | undefined = undefined;
    static userId: number | undefined = undefined;

    static initialize() {

    }

    static setToken(token: string | undefined, userId?: number) {
        this.token = token;
        this.userId = userId;
        if (token !== undefined && token) {
            StorageStore.setItem("user_token", token);
            StorageStore.setItem("user_id", userId + "");
        } else {
            StorageStore.removeItem("user_token");
            StorageStore.removeItem("user_id");
            UserContextOld.setToken(token);
        }
    }

    static getToken() {
        if (this.token) {
            return this.token;
        }
        let token = StorageStore.getItem("user_token");
        if (token) return token;
        token = UserContextOld.getToken() as any;
        if (token) return token;
        return undefined;
    }
    static getUserId() {
        if (this.userId) {
            return this.userId;
        }
        let userId = StorageStore.getItem("user_id");
        return userId ? userId : undefined;
    }
}

export default UserTokenContext;
